// extracted by mini-css-extract-plugin
module.exports = {"card":"QuickBottomNavigation-module--card--Ne2ib","container":"QuickBottomNavigation-module--container--2RbJe","wrapper":"QuickBottomNavigation-module--wrapper--2D3tF"};